import {useEffect, useState} from "react";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
// import { increment, decrement, incrementByAmount } from "../redux/counterSlice";
import { addToCart, removeFromCart, clearCart } from "../redux/cartSlice";


function Shop() {
    /* https://fixstyle.ir/api/public-products*/
    // https://fixstyle.ir/AddCart/502
    const [products, setProducts] = useState([]);

    // const count = useSelector((state) => state.counter.value); // دسترسی به state
    const cartitem2 = useSelector((state) => state.cart.cart); // دسترسی به state
    const dispatch = useDispatch(); // برای ارسال action

    // console.log(cartitem)

    /*const fetchProducts = async () => {
        try {
            // const res = await fetch("http://localhost:8000/ProductsList");
            const res = await fetch("http://localhost:8000/ProductsList");

            if (!res.ok) {
                throw new Error(`HTTP error! status: ${res.status}`);
            }

            const data = await res.json();
            setProducts(data.data);
            console.log(data.data)
        } catch (error) {
            console.error("Fetch error:", error);
        }
    };*/

    const AxsiosData= async ()=>{

            try {
                // const response = await axios.get('http://localhost:8000/ProductsList');
                const response = await axios.get('https://fixstyle.ir/api/public-products');
                console.log(response);
                setProducts(response.data);
            } catch (error) {
                console.error(error);
            }

    }

    useEffect(() => {
        AxsiosData()
    }, []);


    return (
        <div className='container'>
            <div>Shop</div>

            <div className='row g-3'>


                {products.map((product) => (
                    <div className="col-12 col-md-6  col-lg-4 col-xl-3 " key={product.id}>

                        <div className="card ">
                            {/*/img/product/thumbnails/20210904_110234(5).jpg*/}
                            {/*/img/product/sliders/162658362781531.jpeg*/}
                            <img src={"https://fixstyle.ir/img/product/thumbnails/" + product.images?.url}
                                 className="card-img-top" height='200px' alt={product.id}/>
                            <div className="card-body">
                                <h5 className="card-title">  {product.id} -{product.name}</h5>
                                <p className="card-text">
                                    {product.short_description.slice(0, 30)}...


                                </p>
                                {/*<a href={"https://fixstyle.ir/AddCart/"+product.id} className="btn btn-primary">خرید</a>*/}
                              {/*  <a href={"https://fixstyle.ir/AddCart/" + product.id}
                                   className="btn btn-primary">خرید</a>*/}

                                <button className="btn btn-primary" onClick={() => dispatch(addToCart({id: product.id, name: product.name}))}>+ </button>
                                {cartitem2.map((c) =>{
                                    return  c.id===product.id? (<span key={c.id}>{c.quantity}</span>):""

                                }
                                )}

                                {cartitem2.map((c) =>

                                    (c.id === product.id ?
                                        ( <button className="btn btn-danger" key={product.id} onClick={() => dispatch(removeFromCart(product.id))}>- </button>)

                                        : "")


                                )}

                            </div>
                        </div>


                    </div>
                ))}

            </div>
        </div>
    )
}

export default Shop
